import { ApolloClient } from '@apollo/client';
import { isBrowser } from '@utils/isBrowser';

import {
  GET_PRODUCTS,
  GET_SHIPPING_RATE_BY_PRODUCT_VARIANT_ID,
  GET_TAXES_BY_COUNTRY_CODE,
} from '../apollo/api/queries';
import {
  GetShippingRateByProductVariantIdResponse,
  GetTaxesForCountryCodeResponse,
  ProductGateway,
} from '../types/AvantArteProduct';
import {
  GeneratedGetProductsQuery,
  GeneratedGetProductsQueryVariables,
  GeneratedGetShippingRateByProductVariantIdQuery,
  GeneratedGetTaxesByCountryCodeQuery,
} from '../types/generated';
import { CountryCode } from '../types/Locations';

export class AvantArteProductGateway implements ProductGateway {
  constructor(private client: ApolloClient<any>) {
    if (isBrowser()) {
      this.previewToken =
        new URLSearchParams(window.location.search).get('previewsecret') || '';
    }
  }

  private previewToken: string = '';

  public getProducts = async (
    ids: string[],
    shopifyIDs: string[],
    slugs: string[],
  ) => {
    const res = await this.client.query<
      GeneratedGetProductsQuery,
      GeneratedGetProductsQueryVariables
    >({
      query: GET_PRODUCTS,
      fetchPolicy: 'no-cache',
      variables: { ids, shopifyIDs, slugs, previewToken: this.previewToken },
    });

    return res.data.getProducts;
  };

  public async getTaxesForCountryCode(
    countryCode: CountryCode,
  ): Promise<GetTaxesForCountryCodeResponse> {
    const result = await this.client.query<GeneratedGetTaxesByCountryCodeQuery>(
      {
        query: GET_TAXES_BY_COUNTRY_CODE,
        fetchPolicy: 'no-cache',
        variables: { countryCode },
      },
    );

    if (result.data) return { tax: result.data.getTaxesByCountryCode };

    return { tax: void 0 };
  }

  public async getShippingRateByProductVariantId(
    productVariantId: string,
    countryCode: CountryCode,
    currencyCode: CurrencyCode,
  ): Promise<GetShippingRateByProductVariantIdResponse> {
    const result =
      await this.client.query<GeneratedGetShippingRateByProductVariantIdQuery>({
        query: GET_SHIPPING_RATE_BY_PRODUCT_VARIANT_ID,
        fetchPolicy: 'no-cache',
        variables: {
          productVariantID: productVariantId,
          countryCode,
          currencyCode,
        },
      });

    if (result.data)
      return { shippingRate: result.data.getShippingRateByProductVariantID };

    return { shippingRate: void 0 };
  }
}
